import { Component, OnInit, Inject } from '@angular/core';
import { Router  } from '@angular/router';
import { SharedService } from '../../_service/shared.service';
import { LeadsService } from '../../_service/leads.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { FormControl, FormGroupDirective, FormBuilder, FormGroup, NgForm, Validators, FormArray } from '@angular/forms';
@Component({
  selector: 'app-opd-prescription-audit',
  templateUrl: './opd-prescription-audit.component.html',
  styleUrls: ['./opd-prescription-audit.component.css']
})
export class OpdPrescriptionAuditComponent implements OnInit {
  OpdForm: FormGroup;loading:boolean=false;submitted:boolean=false;dataLoaded:boolean=false;uploading:boolean=false;
  constructor(public dialogRef: MatDialogRef<OpdPrescriptionAuditComponent>,@Inject(MAT_DIALOG_DATA) public data: MatDialog,private dialog:MatDialog,
  private router:Router,private sharedapi:SharedService, private leadapi:LeadsService,private formBuilder: FormBuilder) {

  this.OpdForm = this.formBuilder.group({ 
      'opdid' : [null],
      'pres_audit_age' : [null],
      'pres_audit_date' : [null],
      'pres_audit_gender' : [null],
      'pres_audit_medication_advised' : [null],
      'pres_audit_medication_advised_days' : [null],
      'pres_audit_name' : [null],
      'pres_audit_prescription_status' : [null],
      'pres_audit_signature' : [null],
      'pres_audit_surgery_suggest' : [null],
      'pres_audit_surgery_date' : [null],
      'pres_audit_history_investigations' : [null],
      'pres_audit_history_mentioned' : [null],
   });
  }

  ngOnInit(): void {
    this.getOpdDetails();
  }

  getOpdDetails()
  {
    this.dataLoaded = false;
    this.leadapi.getOpdDetails(this.data).subscribe(
    (data:any) => {
      this.dataLoaded = true;
      this.OpdForm.controls['opdid'].setValue(data.data.id);
      this.OpdForm.controls['pres_audit_age'].setValue(data.data.pres_audit_age);
      this.OpdForm.controls['pres_audit_date'].setValue(data.data.pres_audit_date);
      this.OpdForm.controls['pres_audit_gender'].setValue(data.data.pres_audit_gender);
      this.OpdForm.controls['pres_audit_medication_advised'].setValue(data.data.pres_audit_medication_advised);
      this.OpdForm.controls['pres_audit_medication_advised_days'].setValue(data.data.pres_audit_medication_advised_days);
      this.OpdForm.controls['pres_audit_name'].setValue(data.data.pres_audit_name);
      this.OpdForm.controls['pres_audit_prescription_status'].setValue(data.data.pres_audit_prescription_status);
      this.OpdForm.controls['pres_audit_signature'].setValue(data.data.pres_audit_signature);
      this.OpdForm.controls['pres_audit_surgery_suggest'].setValue(data.data.pres_audit_surgery_suggest);
      this.OpdForm.controls['pres_audit_surgery_date'].setValue(data.data.pres_audit_surgery_date);
      this.OpdForm.controls['pres_audit_history_investigations'].setValue(data.data.pres_audit_history_investigations);
      this.OpdForm.controls['pres_audit_history_mentioned'].setValue(data.data.pres_audit_history_mentioned);
    },
    error => {
        this.sharedapi.checkError(error);
    });
  }

  async updateOpdForPrescription()
  { 
    this.submitted = true;
    this.loading = true;
    this.leadapi.savePrescriptionOpdFor(this.OpdForm.value)
    .subscribe((data:any) => {
        this.submitted = false;
        this.loading = false;
        if(data.status)
        {
            this.sharedapi.presentToast(data.msg);
            this.getOpdDetails();
        }else
        {
            this.sharedapi.presentToast(data.msg);
        }
      }, error => 
        {
            this.sharedapi.checkError(error);
        });

  }
          

  CloseModal(): void {
    this.dialogRef.close();
  }


  
}
